export { default } from '@/components/blocks/MobileBottomNav'
